import * as mat from "../components/materials"
import { gsap } from 'gsap'


// ------------------------------------------------------------

const modal = document.querySelector('#modalConnection')
const continue3D = document.querySelector('#closeModalConnection')
let modalOpen

export function realLoader(clock, loadCallback) {

    const loadControl = window.loadControl

    let loaded = 0
    let total = 0
    Object.keys(loadControl.elements).forEach( (key) => {
        loaded += loadControl.elements[key].loaded
        // total += loadControl.elements[key].total
    })
    total = 5437647 // 4722611

    loadControl.values = { loaded, total }
    loadControl.textures = mat.texturesData

    //
    let elements = Math.round( (loaded / total) * 100)
    if( isNaN(elements) || total < 1024) elements = 0
    // loadControl.loadValue = (mat.texturesData.size.percent + elements) / 2
    loadControl.loadValue = elements

    const fixed = `${loadControl.loadValue.toFixed(0)}%`
    document.querySelector('.loader-load-value').innerHTML = fixed
    document.querySelector('.loader-load-bar span').style.width = fixed


    // Connection modal
    // #modalConnection { #closeModalConnection, #jump }
    if( clock.getElapsedTime() > 90 ) {

        if( modalOpen ) return
        modalOpen = true
        modal.style.display = 'flex'
        continue3D.addEventListener('pointerup', () => {
            //
            gsap.to(modal, {
                opacity: 0, duration: 0.5,
                onComplete() {
                    this.targets()[0].remove()
                    modalOpen = false
                }
            })})
    }


    if(loadControl.loadValue === 100 && mat.texturesData.managerState === 'Ready' && !modalOpen ) {

        console.log(total)
        // console.log(loadControl)

        console.log(`[3] All ready at ${(clock.getElapsedTime()).toFixed(2)}s \n    ${( (total + mat.texturesData.size.total) /1024/1024).toFixed(2)}Mb | ${mat.texturesData.total}`)
        loadControl.finish = true

        loadCallback()
    }
}

export const isM = (function isMobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
}())
export function getRealSize(HTMLelement) {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
        //
    let containerStyle = window.getComputedStyle(HTMLelement)

    const object = {}
    object.w = parseInt( containerStyle.width.slice(0, -2) )
    object.h = parseInt( containerStyle.height.slice(0, -2) )

    return object
}

//

export const lerp = (start, end, amt) => { return (1-amt)*start+amt*end }

export const randomNum = (min, max, last) => {
    let v = Math.floor( Math.random() * (max - min + 1) + min )
    if(v == last) { return randomNum(min, max, last) } else { return v }
}
export const randomDec = (min, max) => {
    return (Math.random() * (max - min) + min).toFixed(3)
}